import { render, staticRenderFns } from "./add-brand-modal.vue?vue&type=template&id=391ded36&scoped=true"
import script from "./add-brand-modal.vue?vue&type=script&lang=js"
export * from "./add-brand-modal.vue?vue&type=script&lang=js"
import style0 from "./add-brand-modal.vue?vue&type=style&index=0&id=391ded36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391ded36",
  null
  
)

export default component.exports